module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "ebook-tocn",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "bold CharOverride-1"
  }, [_vm._v("Also by Dawn Lanuza")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "https://publishing.andrewsmcmeel.com/book/the-last-time-ill-write-about-you/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("The Last Time I’ll Write About You")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("The Boyfriend Backtrack")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("What About Today")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("Break-Up Anniversary")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("This Is How It Starts")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "https://publishing.andrewsmcmeel.com/book/you-are-here/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("You Are Here")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "https://publishing.andrewsmcmeel.com/book/stay-a-little-longer/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "italics CharOverride-2"
  }, [_vm._v("Stay a Little Longer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1p"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "text ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("TRIGGER WARNING:")])]), _vm._v(" "), _c('p', {
    staticClass: "text2 ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("This book contains discussions on death, suicide ideation, violence, bullying, injury, self-harm, body image, sexism, and mental health. If you feel triggered in between these pages, feel free to give yourself the space and time to breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "text2 ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Take care of yourself.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  1  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She didn’t know where she was from.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("On the first day of school, freshman year, people tried to know each other by asking three things: name, major, hometown.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She knew the answers to the first two questions, but she’d always answered the last one with a question mark. It wasn’t that she lied; it was true. She had lived in that place longer than any place she’d been in, and yet she refused to call it home. She still thought of it as temporary, and she’d struggled to understand why, but then")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("she remembered.")])]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She once slept in another city")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and woke up in this town.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She’d never seen so much land")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and trees and rocks and colorful flowers")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("bunched up in little bouquets of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("yellow and pink, yellow and pink.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She was happy for a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 ParaOverride-3"
  }, [_vm._v("She thought she’d stumbled upon")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("a place where fairies could exist.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("The fireflies haloed the top of her head,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("crowned her their princess,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("and granted her a wish.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("She was who they’d been waiting for,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("and if she opened her hands,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("a glow would reveal her power:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("a light, blinding and searing.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "text ParaOverride-4"
  }, [_vm._v("That summer, she played to her heart’s content. She ran around the railways and let the dust kiss her feet as she danced and twirled around it. She picked fruits from her uncle’s backyard and ate them until her chin was sticky from the nectar that dripped from her mouth. She convinced herself that she lived in a storybook because, for the first time, she was allowed to dip into a pool of water so cold her insides shivered. She loved her freedom, and she cruised the rivers looking for snails and toads, dared to visit the places where they said mythical creatures roamed.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("And yet.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She knew that summer was ending. She started noticing notebooks piling up for school. The spiral spring had been taken off its sides, and the elders spun colorful yarns around to keep the leaves bound together. They started to bring up June, and it sounded like a threat, another separation from a world she just met.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 ParaOverride-5"
  }, [_vm._v("But the day came when she had to leave. They had her bags packed and everything. They never said she was going home; she would just have to go. And because she was young and braver then, she asked the question no one had been asking.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-4"
  }, [_vm._v("She asked, “When are we going home?”")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("And she knew, the moment those words left her mouth, that she wasn’t.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "text ParaOverride-6"
  }, [_vm._v("She’s been leaving and arriving at places with a cautious heart since then. She’s aware that living in places is temporary, but sometimes she allows herself to be caught up in the magic. Like that summer. With the breeze running its fingers through her hair, whispering promises to her ears as the sun kissed her cheeks to say, “Aren’t you glad you’re here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text2 _idGenParaOverride-1"
  }, [_vm._v("She convinced herself that wherever she is, she can build a home. But at times, she catches herself asking, "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("What is a home? ")]), _vm._v("Did she forget what it was? Did she ever even learn what it should feel like?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  2  ")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent"
  }, [_vm._v("Every once in a while she is convinced that she doesn’t belong here anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent"
  }, [_vm._v("Yet she doesn’t know where she should be just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent"
  }, [_vm._v("She finds herself where she is because she doesn’t know where else to be.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 hanging-indent"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Where would you go? ")]), _vm._v("she asks herself. "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("If everything would be taken care of, where would you rather be?")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent"
  }, [_vm._v("But she can’t see it that way yet.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 hanging-indent"
  }, [_vm._v("Her mind carries all of the worry and the weight.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent"
  }, [_vm._v("Sometimes, when she’s in a new place, wandering and learning its streets, she just hears herself sighing, "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("I must belong somewhere")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text2 hanging-indent"
  }, [_vm._v("She hasn’t found it yet,")]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent"
  }, [_vm._v("but she hasn’t given up on the idea of it.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  3  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I am a suitcase:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("holding these things together,")]), _vm._v(" "), _c('p', {
    staticClass: "text _idGenParaOverride-1"
  }, [_vm._v("keeping them inside.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  4  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I have been walking around your town,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("tiptoeing, in case you’re around.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Then I realized:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("you do not own these streets.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Nobody put a claim on ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("which ends we should")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("or shouldn’t be.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You are merely living,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and so am I.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("So am I.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  5  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text _idGenParaOverride-1"
  }, [_vm._v("The thought of being in the same place as you scares me, but staying away from you for too long scares me in a different way.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  6  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She doesn’t have a bucket list.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Thinking about it felt like")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("enumerating things")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("until she’s ready to die.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("That day, when she ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("boarded that plane,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("sat one row behind")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the emergency exit,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("she thought,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("If this is my last day,")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("I wouldn’t mind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She didn’t like to admit it,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but she feared death")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("when she was a child.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Now she found herself")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("actually thinking,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("It could be any time now.")])]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She used to worry about the things she’d leave:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the mess they would have to clean up for her,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the secrets they’d reveal at her funeral,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the things she didn’t admit for various reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "space-before ParaOverride-3"
  }, [_vm._v("But she’s started talking now.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("She’s doled out apologies")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("to the people who need them.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("She doesn’t sleep with the thought of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("making it better next time.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "space-before ParaOverride-7"
  }, [_vm._v("She tries to make it better "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("now")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("And if it doesn’t work that way,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("she lets it go.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She knows now that she can only do ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("what she can at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She doesn’t waste her energy on someone")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("who won’t—"), _c('span', {
    staticClass: "italics"
  }, [_vm._v("can’t")]), _vm._v("—reciprocate her love.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She doesn’t live with regrets now.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And if she leaves this earth,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("she will.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She’s free from herself now.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  7  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Freedom is looking at your things and thinking, "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("I don’t need all of this.")])]), _vm._v(" "), _c('p', {
    staticClass: "text2 ParaOverride-1"
  }, [_c('span', {
    staticClass: "italics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/LUGGAGE_4B.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  8  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In the winter,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the skies are bland")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and turn the city gray,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but there are nooks and crannies")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in between the alleyways.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("There’s a tiny bookshop")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("with pocket-sized stories")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and a chocolatier")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("with his chocolate-covered cherries.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("A café that was named after a cat")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("that makes the perfect cup ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and a bench in the middle")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in case one needs to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("When you reach that corner,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("remember to look up.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You’ll find that somebody")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("drew you a heart.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("— graffiti")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  9  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He asked her,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Why do you keep writing love poems?")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There are so many things")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in the world that need")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to be discussed:")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("poverty and war,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("deceit and injustice.”")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("And she said,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“What hurt could ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("a little love poem do?")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Every day that we see")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the world crumble,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("how are we not able")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to remember:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("a little bit of love ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("could make this better.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  10  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There are streets that stay alive in your head.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Like St. Kilda and that busy street of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("bakeries,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("window displays of sweets and")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("live music blasting in your ears.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("People from all over the world")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("speaking in their native tongues,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("clinking beer bottles as the sun ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("melts into creamy clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It’s orange and pink,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("violet hues;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("neons, sharp strokes,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("alleys, and walls.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Posters of people")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("writing poetry with their hands.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It’s everyone speaking out at once:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("a harmonious cacophony")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("of lives being lived")]), _vm._v(" "), _c('p', {
    staticClass: "text _idGenParaOverride-1"
  }, [_vm._v("that summer day.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  11  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Her mind is a born voyager,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("always curious about what’s to discover,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("willing to embark on expeditions")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to locate the unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Her heart, however, is a creature of habit.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It is craving the sunlit porch,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the hot pot of chamomile tea,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("a worn-out winter blanket.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She flees because")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("she can’t help but sate")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("her interest,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but she always comes back")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("home to the familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She allows herself to be called")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', [_vm._v("a wanderer,")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but she always knew that her")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("goal was to settle:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to find herself satisfied,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to no longer wonder")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("what was missing")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("from her life.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  12  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They tried so hard to build a home.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There’s a roof above their heads,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but they’re still seeking shelter.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Did they really have the time")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and space to recover?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  13  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She wasn’t one of the kids who wanted")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("her parents to get back together.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There was no together,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("even before.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She saw how her mother blossomed")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("after they left him,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and she would rather have that")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("than recall her silence")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in his presence.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("She learned how to choose herself by her mother’s example.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Not everyone would understand it;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("she remembered people looking at her")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("strangely whenever she said,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“No, I don’t want my father home.”")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("For some people, that made her seem bad,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("like she was the devil child,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but she always knew:")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("you can’t repair something that never worked,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and that was the truth.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  14  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("As she made her way onto")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the Great Ocean Road,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("they talked about forest fires")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and how people learned")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to build their homes")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("with protection in mind,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in case the fires started.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("They will;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("it’s just a matter of time.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("On her left stood trees")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("with no sign of life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("trunks black as charcoal,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("branches spread out.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Standing tall")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("above the wreckage of it all.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("And she’d never felt so proud.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  15  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("A screaming match in the kitchen. They should have christened this new home with kind words and hushed tones.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("For even the most loving words won’t sound very loving in a harsh and raised voice.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  16  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It’s one thing to be a spectator of someone else’s loneliness,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("another thing to be a prisoner of your own.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  17  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I’ve never read your suicide letters,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("never seen them either.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I know that they’re there,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("tucked between the bed")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and your pillows.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Maybe they’ll slip out of")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("your books or sketch pads.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("But I do know this much:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("you’ve had the words")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("written on your face")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("all along.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I read them from the way you recoil,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("body curled into a tight ball.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You never turn your lights on,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the darkness a blanket as you shiver.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You remain quiet during the day")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but a noise of pots and cutlery")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("during the night.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I’ve never read")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("your suicide letters.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I’ve lived with them instead.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  18  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("People started to disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We’d always heard of this,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but it was a different time—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("that is, until the names")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("of the missing sounded familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Like Joni, who I grew up with,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("lived next door,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("played with my brother after school.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They said he was one of them, too.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("He used to walk around the corridors,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("wore shirts that were washed and ironed.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He was nicer than most,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("didn’t care if someone was cool.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He taught me how to jiggy that one time")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("’cause my limbs didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He said, “Just bend your knees, ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("move to the beat.”")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("But that was then.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We had lives outside,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("grew up.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "text2 ParaOverride-3"
  }, [_vm._v("He slipped out one night,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("only to be taken in")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("as an exchange ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("for someone.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 ParaOverride-9"
  }, [_vm._v("Caught, red-handed.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He ran through the streets")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("carrying packets.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Door-to-door deliveries,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("cloaked by darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I didn’t know how he")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("had gotten into this.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("He was the boy I knew,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("led the prayers when we were both in")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Catholic school.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He always had a pretty smile.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("That’s what I remembered")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("People started to disappear")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("long before I even noticed.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They skipped towns.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They lay low.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "text2 ParaOverride-3"
  }, [_vm._v("The unfortunate ones got caught.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("The lucky ones chanced upon redemption.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("The poor ones were found on the road.")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("Sometimes wrapped up like animals,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("others left to bleed on the very streets")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("they grew up in,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("in front of the people")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("they grew up with.")]), _vm._v(" "), _c('p', {
    staticClass: "space-before ParaOverride-3"
  }, [_vm._v("People disappeared all the time,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("but now we feel them missing.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They warned us about this,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and yet we just keep watching.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  19  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You also disappeared, didn’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You ran to a far enough place")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to avoid what was happening to you")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and everyone you knew.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("But even with the distance, you learned:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("no amount of miles could make you")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("any less")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("frightened.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("There’s a scribble")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("at the bottom of a page")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("of your old notebook.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Once you were afraid, too.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Someone once told you:")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("whatever it is that scares you,")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("do that.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  20  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Year twenty-nine was")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("learning to say yes,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("knowing when to say no.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Finding a place,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("a familiar face,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("having the courage to go.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  21  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Half of me is worried about the lives I’m not living;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("half of me is too tired to do anything about it.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  22  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("How hard is it to leave someone,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("wondering if you’ll come back home")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to a corpse?")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You either choose to stay")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("or leave so fast,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("so far away, that")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("you won’t have to see")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the blood trail,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("hear the last hitching breath,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("smell the stink of a day-old body,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("taste the chill of their stiff fingers")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("where there is no pulse,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("no blood,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("no life,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("no recognition of the man")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("you loved.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("How do you carry")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the guilt of leaving")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("for a moment")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("for yourself?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "text2 ParaOverride-3"
  }, [_vm._v("How hard is it")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("to live with someone")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("who wants to die,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("knowing they want to live")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but somehow can’t quite make it?")]), _vm._v(" "), _c('p', {
    staticClass: "space-before"
  }, [_vm._v("It’s like standing over a cliff, ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("your hand stretched out,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("hearing yourself yell, “Take it!”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You see it in their eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("They want it.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You hold on and pull them up,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but the weight, even for you,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("is too much.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You strain your muscles—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("no, don’t let go.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You get that resigned look,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and you know.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("They will let you go—")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and soon.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  23  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She’s traveled so much the past year,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but she’s barely heard the words:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Should the cabin lose pressure,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("oxygen masks will drop from the overhead area.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Please place the mask over your mouth and nose")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("before assisting others.”")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("He had been so willing to die,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and she had been so willing to save him.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  24  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I must find a way ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to still choose myself despite")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("holding on to you.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  25  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When I was young, I learned about a man named Ettore Majorana, who chose to disappear. He was young and very smart, but one day, he bought a ticket to Naples, got on the boat, and never returned. He left a note to his friends to apologize for his absence, then sent a telegram to cancel all of his commitments.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("There were several hypotheses regarding his disappearance, including suicide, but I always believed that he was alive. I chose to believe that he was one of the few ones who managed to vanish, chose to build his life the way he "), _c('br'), _vm._v("wanted it.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I never forgot about Ettore. I had him in the back of my mind, pictured him living his best life, far different from the one he left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("Recently, I decided to type his name in the search box and learned that his case of disappearance had been closed. Someone witnessed him in Buenos Aires, doing god knows what, but I smiled at that.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("As I sit here with my glass of wine, I make a toast:")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("to Ettore,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("who disappeared— ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but also")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to the man he chose to be")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and the life he must have fully lived.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  26  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Some things you love")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("won’t always serve their purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You have to let go.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  27  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I didn’t want to ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("just survive this life.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I wanted to live.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  28  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I sat on Fed Square")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("as the sun set slow.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There were pigeons ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("trying to fight for a crumb")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and a family of four.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I dared to ask,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“Can I actually live like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("And I meant: transient.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You sat next to me")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and said, “Sure.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("As long as you always")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("have a place to dock.”")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I’ve been away since;")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I’m still wondering where that was.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  29  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("On the train ride to the city, there was a boy who was making kissing sounds with his girl. Every sentence would end with a kiss. As an unwilling spectator, I started to wince, but the truth is—")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I remembered when your sentences all ended with your lips, hitting the sides of my cheeks, my temples, my skin. I sat there not knowing what to do with my hands, my chest, my lungs, my fingertips.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 hanging-indent",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v("I didn’t know what to do with you, soaking my skin with your wet kisses and your love—")]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("my love")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hanging-indent",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v("I didn’t know what to do with your love.")]), _vm._v(" "), _c('p', {
    staticClass: "text2 hanging-indent",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v("I didn’t know how to kiss you back, didn’t know how to love you just as much when the truth is I do.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("I do")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text2 hanging-indent",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v("I just didn’t know how to show you. I had to learn from years and years of replacement lovers, storybooks, and novels. Now I think I know.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Yet there is no you left to show.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  30  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("She wanted to be alone,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("but with someone.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("That should make sense.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  31  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You stopped intruding on my dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In fact, I am convinced:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("you now live in my subconscious,")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("you little ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("castaway.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You start fires and let them")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("burn through the night.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You take from my land,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("let your feet sink through")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the mud.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You run mad,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("leaving foot trails in the sand.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You throw spears,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("climb trees.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You seek for sustenance,")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("you hungry")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("little thing.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("You ignore my call")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to make no sound.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You spell out capital")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("H - E - L - P")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("with seashells")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and granite.")]), _vm._v(" "), _c('p', {
    staticClass: "space-before ParaOverride-3"
  }, [_vm._v("You captive,")]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-3"
  }, [_vm._v("you captivate me")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("still.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('p', {
    staticClass: "space-before"
  }, [_vm._v("You show up every once in a while")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to remind me of the promises")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I broke,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("the lives I could have hoped")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("to live, to make sure")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I don’t forget.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I’ve got you trapped")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("on a little island")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("I am your shipwreck,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("thunder and lightning.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I brought you here to abandon,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("so you hunt me down")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("and haunt me for it.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("  32  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The roaring twenties:")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("learning how to be alone,")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("wondering, "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("How long?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ca8a5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IMustBelong_ebook.vue
// module id = 60
// module chunks = 0